import React from 'react';
import { Box } from '@mui/material';
import { SubContentProps } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import ContentDescription, {
  ContentDivider,
} from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import Switch from '@/components/@IntranetLibrary/Switch';
import useAlarmSettingProps from './useAlarmSettingProps';
import ApprovalAlarmSetting from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/AlarmSetting/Approval';
import {
  Description,
  DescriptionContent,
  DescriptionTitle,
  Icon,
  Menu,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/AlarmSetting/style';
import FormControlLabel from '@mui/material/FormControlLabel';
import AngleBracketRightIcon from '@/public/icons/angle_bracket_right.svg';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useTranslation } from 'react-i18next';

const AlarmSettingContent = (props: SubContentProps) => {
  const {
    approvalSummary,
    isJiraActivated,
    jiraServiceName,
    isLoading,
    handleChangeAlarm,
    onClickApprovalMenu,
    ...approvalAlarmProps
  } = useAlarmSettingProps(props);
  const { t } = useTranslation();
  const mypageEventTracker = useMypageEventTracker();

  return (
    <>
      <ContentDivider>
        <ContentDescription hasVerticalMargin={true}>
          {t('MYPAGE.알림을 켜면 푸시알림과 E-mail로 알림을 받을 수 있어요.')}
        </ContentDescription>
        <Menu
          onClick={() => {
            onClickApprovalMenu();

            // GA Mypage - 20번
            mypageEventTracker(MypageEventName.clickEvent, {
              area_name: '알림 설정',
              contents: 'APPROVAL',
              status: undefined,
              description: '알람 설정 상세',
            });
          }}
          sx={{ margin: '16px 0' }}
        >
          <Icon>
            <Box
              sx={{
                width: '32px',
                height: '32px',
                background: 'rgba(0, 102, 204, 0.12)',
                borderRadius: '4px',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                stroke="#0066CC"
              >
                <path
                  d="M15.1861 26.2401H10.0661C8.65224 26.2401 7.50609 25.0939 7.5061 23.6801L7.5062 8.32012C7.50621 6.90627 8.65236 5.76013 10.0662 5.76013H21.5865C23.0003 5.76013 24.1465 6.90628 24.1465 8.32013V15.3601M19.0265 22.6135L21.3732 24.9601L26.4932 19.8399M11.9865 10.8801H19.6665M11.9865 14.7201H19.6665M11.9865 18.5601H15.8265"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          </Icon>
          <Description>
            <DescriptionTitle>{'APPROVAL'}</DescriptionTitle>
            <DescriptionContent>{approvalSummary}</DescriptionContent>
          </Description>
          <AngleBracketRightIcon
            width={'24'}
            height={'24'}
            stroke={'#888D96'}
          />
        </Menu>
        <FormControlLabel
          sx={{ margin: '16px 0' }}
          control={
            <Menu>
              <Icon>
                <img
                  src={'/icons/logo/jira.png'}
                  srcSet="/icons/logo/jira.png 1x, /icons/logo/jira@2x.png 2x, /icons/logo/jira@3x.png 3x"
                  alt={'jira icon'}
                  width={56}
                  height={56}
                />
              </Icon>
              <Description>
                <DescriptionTitle>{jiraServiceName}</DescriptionTitle>
                <DescriptionContent>
                  {t(
                    'MYPAGE.나와 관련된 티켓의 업데이트가 있을 때 알림을 받아요.',
                  )}
                </DescriptionContent>
              </Description>
              <Switch
                checked={isJiraActivated}
                onChange={(event, checked) => {
                  handleChangeAlarm(event, checked);

                  // GA Mypage - 21번
                  mypageEventTracker(MypageEventName.clickEvent, {
                    area_name: '알림 설정',
                    contents: 'IT Service',
                    status: checked,
                    description: '알람 설정 토글',
                  });
                }}
                disabled={isLoading}
                name={'jira'}
              />
            </Menu>
          }
          label={''}
        />
      </ContentDivider>
      <ApprovalAlarmSetting
        {...approvalAlarmProps}
        handleChangeAlarm={handleChangeAlarm}
        isLoading={isLoading}
      />
    </>
  );
};

export default AlarmSettingContent;
